import React from "react";
import cx from "classnames";
import { GatsbyImage } from "gatsby-plugin-image";
import Link from "../../Link";
import { useTranslation } from "react-i18next";

const ListedCoinInfoCard = ({
  classNames,
  linkTo,
  featuredImageSharp,
  fullName,
  tickerSymbol,
  excerpt,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={cx(
        "coin-info__card my-4 d-flex align-items-stretch",
        classNames
      )}
    >
      <Link
        to={linkTo}
        className="card shadow"
        style={{
          borderRadius: "0.75rem",
        }}
      >
        {featuredImageSharp && (
          <GatsbyImage
            image={featuredImageSharp.childImageSharp.gatsbyImageData}
            className="img-fluid"
            alt={""}
          />
        )}

        <div
          className="card-body pt-1 w-100 position-relative"
          style={{
            color: "#152b43",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "1rem",
              position: "absolute",
              top: "-1rem",
              left: 0,
              background: "#ffffff",
            }}
          />
          <div
            className={cx("w-100", { "text-center mt-3": excerpt })}
            style={{
              backgroundColor: "#ffffff",
            }}
          >
            {!excerpt && (
              <>
                <span>{t("coinInfo.learnMoreAbout")} </span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: tickerSymbol,
                  }}
                />
              </>
            )}

            <h5
              className="mt-1 mb-2"
              dangerouslySetInnerHTML={{
                __html: fullName,
              }}
            />

            {excerpt && (
              <div
                className="mt-3"
                dangerouslySetInnerHTML={{ __html: excerpt }}
              />
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ListedCoinInfoCard;
